import { Box, Divider, Tooltip, Typography } from "@mui/material";
import { Apartment, Person, Workspaces } from "@mui/icons-material";
import { KeyDriveBodyMin } from "../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { useTranslation } from "react-i18next";

export interface IDashboardCardOrganization {
    name: string;
    users: number;
    workspaceQuantity?: number;
}

export const DashboardCardOrganization = ({
    name,
    users,
    workspaceQuantity
}: IDashboardCardOrganization) => {

    const { t } = useTranslation();

    return (
        <Box
            sx={{
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                borderRadius: "4px",
                opacity: 1,
            }}
            display="flex"
            flexDirection="column"
            border="1px solid #0000001A"
            borderRadius="4px"
            width="100%"
            height="fit-content"
        >
            <Box
                sx={{ padding: "12px" }}
                display="flex"
                flexDirection={"column"}
            >
                <Box sx={{ display: "flex", gap: "8px", paddingBottom: "12px" }}>
                    <Box
                        width="22px"
                        height="22px"
                        sx={{
                            backgroundColor: "#22638D40"
                        }}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        borderRadius="2px"
                    >
                        <Apartment
                            fontSize="small"
                            sx={{
                                color: "#22638D",
                            }}
                        />
                    </Box>
                    <Tooltip title={name}>
                        <Typography
                            sx={{
                                textAlign: "left",
                                font: "normal normal 600 16px/21px Segoe UI",
                                letterSpacing: "0px",
                                color: "#2D2D2D",
                                opacity: 1,
                                display: "inline-block",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {name}
                        </Typography>
                    </Tooltip>
                </Box>
                <Divider />
                <Box sx={{ margin: '4px 0 12px 0' }} display={"flex"} justifyContent="space-between" alignItems="start">
                    <Box display="flex" alignItems="center" gap={1}>
                        <Box
                            width="22px"
                            height="22px"
                            sx={{
                                backgroundColor: "#22638D40"
                            }}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            borderRadius="2px"
                        >
                            <Person sx={{ color: "#22638D" }} />
                        </Box>
                        <KeyDriveBodyMin 
                            text={t("AdminConsole.Users")}
                            color="#2d2d2d"
                        />
                    </Box>
                    <Typography
                        sx={{
                            font: "normal normal normal 14px/21px Segoe UI",
                            letterSpacing: "0px",
                            color: "#969696",
                            display: "inline",
                        }}
                    >
                        { users }
                    </Typography>
                </Box>
                <Box sx={{ margin: '0 0 12px 0' }} display={"flex"} justifyContent="space-between" alignItems="start">
                    <Box display="flex" alignItems="center" gap={1}>
                        <Box
                            width="22px"
                            height="22px"
                            sx={{
                                backgroundColor: "#22638D40"
                            }}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            borderRadius="2px"
                        >
                            <Workspaces sx={{ color: "#22638D" }} />
                        </Box>
                        <KeyDriveBodyMin 
                            text={"Workspaces"}
                            color="#2d2d2d"
                        />
                    </Box>
                    <Typography
                        sx={{
                            font: "normal normal normal 14px/21px Segoe UI",
                            letterSpacing: "0px",
                            color: "#969696",
                            display: "inline",
                        }}
                    >
                        { workspaceQuantity }
                    </Typography>
                </Box>
            </Box>

        </Box>
    )
}